import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

const MAX_RETRIES = 2;

/** Retry only transient failures: no response at all, 408 or 5xx. 4xx answers are final. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES || !axios.isAxiosError(error) || axios.isCancel(error)) return false;
  const status = error.response?.status;
  return status === undefined || status === 408 || status >= 500;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: shouldRetry,
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * Options for queries whose responses carry private URLs (`/api/files/…`, deals, messages,
 * verification — SPEC-FRONTEND §2): signed links stay valid ~10 minutes, so a longer stale time
 * keeps `<img>` sources stable instead of reloading images on every refetch.
 */
export const PRIVATE_QUERY_OPTIONS = {
  staleTime: 60_000,
  refetchOnWindowFocus: true,
} as const;
